//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import { useQuery } from "@apollo/client";
import { FIND_COMMENTS_BY_SECTION, FIND_VOTES_BY_SECTION } from "queries";
import { Button, Card, CardContent } from "@mui/material";
//import { Link } from "react-router-dom";

// Material Kit 2 React examples
//import DefaultFooter from "examples/Footers/DefaultFooter";
//import Card from "@mui/material/Card";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/comments/DesignBlocks";
//import Pages from "pages/Presentation/comments/Pages";
//import Testimonials from "pages/Presentation/comments/Testimonials";
//import Download from "pages/Presentation/comments/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React, { useState, useEffect } from "react";
// Routes
//import routes from "routes";
//import footerRoutes from "footer.routes";
// Images
//import bgImage from "assets/images/strategia.jpg";
//import { ALL_MUNICIPALITIES } from "queries";
import { useParams } from "react-router-dom";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Commentpublic = ({ selectedKunta, setSelectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  const [comments, setComments] = useState([]);
  const [votes, setVotes] = useState([]);
  //console.log(votes);
  let section = useParams().id;
  const votessw = useQuery(FIND_VOTES_BY_SECTION, {
    pollInterval: 100000,
    variables: { section },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesBySection;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.commentid === p).length;
  }
  //const [ideas, setIdeas] = useState("");
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideatext, setIdeatext] = useState("");
  //const [selected, setSelected] = useState([]);
  const commentssw = useQuery(FIND_COMMENTS_BY_SECTION, {
    pollInterval: 100000,
    variables: { sectionid: section },
  });

  /*useEffect(() => {
    let valittu = comments.filter(function (el) {
      return el.agendaid === meeting;
    });
    //console.log(valittu);
    setSelected(valittu);
  }, [selectedKunta, comments]);*/
  useEffect(() => {
    let commentss = [];
    //let municipalitiess = [];
    if (commentssw.data) {
      commentss = commentssw.data.findCommentsBySection;
      //setOrgans(organss);
      //console.log(commentss);
      //let secs = commentss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setcomments(secs);
      setComments(commentss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [commentssw]);
  const handleVote = () => {
    window.confirm("Sinun on kirjauduttava voidaksesi äänestää");
  };
  return (
    <>
      <MKTypography
        variant="h1"
        color="black"
        mt={-6}
        mb={1}
        sx={({ breakpoints, typography: { size } }) => ({
          [breakpoints.down("md")]: {
            fontSize: size["3xl"],
          },
        })}
      >
        Lisätiedot
      </MKTypography>
      <br />
      {comments.map((p, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>{p.commenttext}</MKTypography>
            <Button variant="contained" style={{ color: "white" }} onClick={() => handleVote()}>
              👍 {voteCount(p.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Commentpublic;
